<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>

      <!-- 全局可拖拽在线客服气泡 -->
      <div
        v-if="showKefu"
        id="draggable-kefu"
        class="custom-kefu-bubble"
        :style="{ left: position.x + 'px', top: position.y + 'px' }"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
        @click="onBubbleClick"
      >
        <!-- 收到新消息时的临时提示框 -->
        <transition name="van-fade">
          <div v-if="msgHint" class="msg-hint-popup">
            {{ msgHint }}
          </div>
        </transition>

        <div class="bubble-content">
          <span class="bubble-text">Ready to chat?</span>
          <div class="icon-wrap">
            <van-icon name="chat" size="24px" color="#fff" />
            <span class="unread-dot" v-if="unreadCount > 0">{{ unreadCount }}</span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status: 0,
      showKefu: false, // 默认隐藏，通过路由监听控制显示
      unreadCount: 0,
      msgHint: "",
      msgTimer: null,
      // 初始位置
      position: { x: window.innerWidth - 220, y: window.innerHeight - 150 },
      dragging: false,
      isRealDrag: false,
      startPos: { x: 0, y: 0 },
      touchStartPos: { x: 0, y: 0 }
    };
  },
  watch: {
    // 监听路由变化
    '$route': {
      handler(to) {
        // 仅在 /mine (个人中心) 页面显示气泡
        // 注意：根据你的路由配置，路径可能是 /mine 或 /Mine
        this.showKefu = to.path.toLowerCase() === '/mine';
      },
      immediate: true // 初始加载时也执行一次
    }
  },
  methods: {
    initChatwoot() {
      const _this = this;
      window.chatwootSettings = {
        position: "right",
        type: "standard",
        launcherTitle: "Chat",
        hideMessageBubble: true, // 隐藏原生气泡
      };

      (function(d, t) {
        var BASE_URL = "https://app.chatwoot.com";
        var g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
        g.src = BASE_URL + "/packs/js/sdk.js";
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          window.chatwootSDK.run({
            websiteToken: 'i1E8BjX5ycNJahgrPWfcmpkw',
            baseUrl: BASE_URL
          });
        }
      })(document, "script");

      window.addEventListener('chatwoot:unread-message-count-update', function(event) {
        _this.unreadCount = event.detail;
      });

      window.addEventListener('chatwoot:on-message', function(event) {
        const message = event.detail;
        if (message.message_type === 'outgoing' || message.message_type === 1) {
          let content = message.content || "New message";
          content = content.replace(/<[^>]+>/g, "");
          _this.msgHint = content;
          if (_this.msgTimer) clearTimeout(_this.msgTimer);
          _this.msgTimer = setTimeout(() => { _this.msgHint = ""; }, 5000);
        }
      });
    },

    onBubbleClick() {
      // 只有在没有发生真实拖拽的情况下才触发点击
      if (!this.isRealDrag) {
        if (window.$chatwoot) {
          window.$chatwoot.toggle("open");
          this.msgHint = "";
        }
      }
    },

    onTouchStart(e) {
      this.dragging = true;
      this.isRealDrag = false;
      const touch = e.touches[0];
      this.touchStartPos.x = touch.clientX;
      this.touchStartPos.y = touch.clientY;
      this.startPos.x = touch.clientX - this.position.x;
      this.startPos.y = touch.clientY - this.position.y;
    },
    onTouchMove(e) {
      if (!this.dragging) return;
      const touch = e.touches[0];

      // 判断位移，防止误触
      const moveX = Math.abs(touch.clientX - this.touchStartPos.x);
      const moveY = Math.abs(touch.clientY - this.touchStartPos.y);
      if (moveX > 5 || moveY > 5) {
        this.isRealDrag = true;
      }

      if (this.isRealDrag) {
        if (e.cancelable) e.preventDefault();
        let newX = touch.clientX - this.startPos.x;
        let newY = touch.clientY - this.startPos.y;

        // 边界检测
        const padding = 10;
        const bubbleWidth = 200;
        newX = Math.max(padding, Math.min(newX, window.innerWidth - bubbleWidth - padding));
        newY = Math.max(padding, Math.min(newY, window.innerHeight - 80 - padding));

        this.position.x = newX;
        this.position.y = newY;
      }
    },
    onTouchEnd() {
      this.dragging = false;
      // 侧边吸附
      if (this.isRealDrag) {
        const bubbleWidth = 200;
        if (this.position.x > (window.innerWidth - bubbleWidth) / 2) {
          this.position.x = window.innerWidth - bubbleWidth - 10;
        } else {
          this.position.x = 10;
        }
      }
    },

    initLangStatus() {
      const currentLang = localStorage.getItem("lang") || "en";
      this.$http({
        method: "get",
        url: "replaceLang",
        data: { lang: currentLang },
      }).then(() => {
        this.getBaseInfo();
      });
    },
    getBaseInfo(){
      this.$http({ method: 'get', url: 'base_info' }).then(res=>{
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }
  },
  created(){
    this.initLangStatus();
    this.initChatwoot();
  }
}
</script>

<style>
/* 1. 自定义气泡样式 */
.custom-kefu-bubble {
  position: fixed;
  padding: 10px 24px;
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(125, 118, 239, 0.4);
  z-index: 9999; /* 稍微降低层级，让聊天窗口能覆盖它 */
  touch-action: none;
  border: 1px solid rgba(255,255,255,0.4);
}

.bubble-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.bubble-text {
  color: #fff;
  font-size: 26px;
  font-weight: 500;
  white-space: nowrap;
}

.icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.unread-dot {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #ff4d4f;
  color: white;
  font-size: 18px;
  min-width: 28px;
  height: 28px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  font-weight: bold;
}

/* 2. 消息提示弹窗 */
.msg-hint-popup {
  position: absolute;
  bottom: 125%;
  right: 0;
  background: #fff;
  color: #333;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 24px;
  width: 280px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.2);
  border: 1px solid #eee;
  z-index: 10000;
}
.msg-hint-popup::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 20px;
  border: 10px solid transparent;
  border-top-color: #fff;
}

/* 3. 精准屏蔽控制 */
/* 隐藏原生启动器气泡 */
.woot-widget-bubble,
.woot--bubble-holder,
#chatwoot-widget-bubble {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

/* 确保聊天窗口（iframe）在展开时可以显示 */
.woot-widget-holder {
  z-index: 2147483647 !important; /* 浏览器允许的最大层级 */
}

body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
  background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;
}
*, :after, :before { box-sizing: border-box; }
</style>